import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App grain min-h-screen bg-[#050505] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0e0e0e",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 0,
            color: "#fafafa",
          },
        }}
      />
    </div>
  );
}

export default App;
